/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserLoginResVo } from './UserLoginResVo';
import {
    UserLoginResVoFromJSON,
    UserLoginResVoFromJSONTyped,
    UserLoginResVoToJSON,
    UserLoginResVoToJSONTyped,
} from './UserLoginResVo';

/**
 * 
 * @export
 * @interface ResponseUserLoginResVo
 */
export interface ResponseUserLoginResVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseUserLoginResVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseUserLoginResVo
     */
    message?: string;
    /**
     * 
     * @type {UserLoginResVo}
     * @memberof ResponseUserLoginResVo
     */
    data?: UserLoginResVo;
}

/**
 * Check if a given object implements the ResponseUserLoginResVo interface.
 */
export function instanceOfResponseUserLoginResVo(value: object): value is ResponseUserLoginResVo {
    return true;
}

export function ResponseUserLoginResVoFromJSON(json: any): ResponseUserLoginResVo {
    return ResponseUserLoginResVoFromJSONTyped(json, false);
}

export function ResponseUserLoginResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseUserLoginResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : UserLoginResVoFromJSON(json['data']),
    };
}

export function ResponseUserLoginResVoToJSON(json: any): ResponseUserLoginResVo {
    return ResponseUserLoginResVoToJSONTyped(json, false);
}

export function ResponseUserLoginResVoToJSONTyped(value?: ResponseUserLoginResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': UserLoginResVoToJSON(value['data']),
    };
}

